import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { routes as AADRoutes } from './modules/aad-login/aad-login.routes';
import { routes as LoginRoutes } from './modules/login/login.routes';
import {WelcomeComponent} from "./modules/welcome/welcome.component";
const routes: Routes = [
  {
    path: '',
    redirectTo: 'web/chatbot',
    pathMatch: 'full',
  },
  {
    path: 'wecom/page',
    loadChildren: () =>
      import('./modules/chatbot/chatbot.routes').then((m) => m.routes),
  },
  {
    path: 'web/chatbot',
    // add chatbot web component here
    loadChildren: () =>
        import('./modules/chatbot/chatbot.routes').then((m) => m.webChatRoutes),
  },
  {
    path: 'web/noauth/page',
    loadChildren: () =>
      import('./modules/public/public.routes').then((m) => m.routes),
  },
];
if (environment.production) {
  routes.push(...AADRoutes);
} else {
  // routes.push(...LoginRoutes);
}
// routes.push(...AADRoutes);
export { routes };
